import { Component, Inject } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, Validators, UntypedFormGroup } from '@angular/forms';

interface FormControls {
  note: AbstractControl;
}

interface FormValuesAsJson {
  note: string;
}

@Component({
  selector: 'app-note-editor-modal',
  templateUrl: './note-editor-modal.component.html',
  styleUrls: ['./note-editor-modal.component.scss'],
  standalone: false
})
export class NoteEditorModalComponent {

  note: string;
  form: UntypedFormGroup;

  constructor(
    private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<NoteEditorModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { note: string; wasSubmitted: boolean; }
  ) {
    this.form = this.fb.group({
      note: this.fb.control(data.note || '', Validators.maxLength(150))
    });
    if (data.wasSubmitted) {
      this.form.disable();
    }
  }

  get formControls(): FormControls {
    return this.form.controls as unknown as FormControls;
  }
  get formValuesAsJson(): FormValuesAsJson {
    return this.form.value;
  }

  onSave(): void {
    if (this.form.valid) {
      this.dialogRef.close(this.formValuesAsJson.note);
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}